import { pyRound } from "./pyRound";

export const COLUMN_RENAMING = {
  ccetests: {
    saturationPressure: "Saturation Pressure (psia)",
    testTemperature: "CCE Test Temperature (F)",
    cceTestStepsstepPressure: "CCE stepPressure",
    cceTestStepsrelativeVolumeRatio: "CCE Vr",
    cceTestStepsgasZFactor: "CCE gas Z Factor",
    cceTestStepsliquidFractionSat: "CCE liquidFractionSat",
    cceTestStepsoilDensity: "CCE Oil Density (g/cc)",
    cceTestStepsoilCompressibility: "Oil Compressibility (10-6 x psi-1)",
  },
  dltests: {
    saturationPressure: "dl SaturationPressure",
    testTemperature: "dl Test Temperature (F)",
    dlTestStepsstepPressure: "dl StepPressure",
    dlTestStepsoilDensity: "dl Oil Density (g/cc)",
    dlTestStepsoilFormationVolumeFactor: "dl Bo (bbl/stb)",
    dlTestStepssolutionGORMeasured: "dl Rs (scf/stb)",
    dlTestStepsgasZFactor: "dl gasZFactor",
    dlTestStepsgasFormationVolumeFactor: "dl gasFormationVolumeFactor",
    dlTestStepsgasGravity: "dl gasGravity",
    dlTestStepsstepNumber: "dl TestNumber",
    apiGravity: "API Gravity - DL Test",
    residualOilDensity: "Residual Oil Density",
  },
  viscositytests: {
    saturationPressure: "viscosity SaturationPressure",
    testTemperature: "viscosity Test Temperature (F)",
    viscosityTestStepstestNumber: "viscosity TestNumber",
    viscosityTestStepsstepPressure: "viscosity StepPressure",
    viscosityTestStepsoilViscosity: "Oil Viscosity (cP)",
    gasViscosity: "Gas Viscosity (cP)",
    oilGasViscosityRatio: "Viscosity Ratio",
  },
  cvdtests: {
    saturationPressure: "cvd SaturationPressure",
    testTemperature: "cvd Test Temperature (F)",
    CVDTestStepstepPressure: "cvd StepPressure",
    CVDTestStepliquidFraction: "cvd LiquidFraction",
    CVDTestStepgasZFactor: "cvd Gas Z Factor",
    CVDTestStepcumulativeFluidProducedFraction: "cvd CumulativeFluidProducedFraction",
    cvdTestStepsstepNumber: "cvd TestNumber",
  },
  compositiontests: {},
};

const REVERSE_RENAMING = (() => {
  const reverse = {};
  for (const [table, mapping] of Object.entries(COLUMN_RENAMING)) {
    for (const [original, renamed] of Object.entries(mapping)) {
      reverse[renamed] = [table, original];
    }
  }
  return reverse;
})();

export function getDisplay(tables, tableName, fieldName) {
  const table = Array.isArray(tables) ? tables.find((t) => t && t.test === tableName) : null;
  const field = table && table.metaData ? table.metaData[fieldName] : null;
  if (field) {
    return {
      displayName: field.displayName !== undefined ? field.displayName : fieldName,
      digits: field.decimals !== undefined ? field.decimals : 0,
    };
  }
  return { displayName: fieldName, digits: 0 };
}

const COMPONENT_COLUMNS = new Set([
  "C1", "C2", "C3", "i-C4", "n-C4", "i-C5", "n-C5", "C6", "C7", "C8", "C9", "C10", "C11", "C12",
  "C13", "C14", "C15", "C16", "C17", "C18", "C19", "C20", "C21", "C22", "C23", "C24", "C25", "C26",
  "C27", "C28", "C29", "C30", "C31", "C32", "C33", "C34", "C35", "N2", "CO2", "H2S",
]);
const PLUS_FRACTION_COLUMNS = new Set(["C7+", "C12+", "C20+", "C36+"]);
const BULK_PROPERTY_KEYS = {
  "GOR (scf/stb)": "flashGOR",
  "API deg": "oilAPIGravity",
  "Oil Molar Mass (g/mol)": "avgMolecularWeight",
  "Gas Gravity": "gasGravity",
  "Gas Z Factor": "gasZFactor",
};

export function getMetadataKeyForColumn(columnName) {
  if (REVERSE_RENAMING[columnName]) return REVERSE_RENAMING[columnName];
  if (COMPONENT_COLUMNS.has(columnName) || PLUS_FRACTION_COLUMNS.has(columnName)) {
    return ["compositiontests", "compositionoverall_MoleFraction"];
  }
  if (columnName.includes(" MW")) return ["compositiontests", "compositionoverall_MW"];
  if (columnName.includes(" Density")) return ["compositiontests", "compositionoverall_Density"];
  if (BULK_PROPERTY_KEYS[columnName]) return ["compositiontests", BULK_PROPERTY_KEYS[columnName]];
  return ["compositiontests", "compositionoverall_MoleFraction"];
}

export function digitsForColumn(tables, columnName) {
  const [table, key] = getMetadataKeyForColumn(columnName);
  const digits = getDisplay(tables, table, key).digits;
  return digits == null ? 0 : Number(digits) || 0;
}

export function formatSliderRange(minVal, maxVal, digits) {
  if (digits === 0) return [Math.trunc(pyRound(minVal)), Math.trunc(pyRound(maxVal))];
  return [pyRound(minVal, digits), pyRound(maxVal, digits)];
}
